import React from 'react';
import SectionHeader from '../components/SectionHeader';

export default function About() {
    return (
        <div className="page-wrapper">
            <div className="container">
                <SectionHeader title="About This Site" />

                <div className="card">
                    <div className="card-body" style={{ maxWidth: 680, margin: '0 auto', lineHeight: 1.8 }}>
                        <p>Scott Mason originally created8this site with <b><u>.Net 7</u></b>, now he has rebuilt in <b><u>React</u></b>.</p>
                        <p>It is not all about functionality — Scott made an attempt to enhance the UX/UI as well.</p>
                        <p>It demonstrates .Net's ability to connect to almost any online data source.</p>
                        <p>It uses <strong>MS SQL Server</strong> as the database.</p>
                        <p>It uses the <strong>Repository Pattern</strong>.</p>
                        <p>As well as <strong>MVVM</strong> (Model View View Model).</p>
                        <p>The "eCommerce" section demonstrates the look and feel as well as the functionality of a modern eCommerce site.</p>
                        <p>You may register yourself or use one of the preexisting users to see all the functionality.</p>
                        <br />
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Original design by DotNetMastery. Rebuilt in React by Scott Mason.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
